import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import { getAxiosCancelToken } from "../../utils/getAxiosCancelToken";

let cancelToken;

const getAllTopics = (searchText, pageNo, pageSize) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ORGANIZE.GET_ALL_TOPICS(searchText, pageNo, pageSize),
    "",
    cancelToken
  );
};

export default getAllTopics;

